import Vue from 'vue'
import { Toast } from 'vant';
Vue.use(Toast);

import '../cube-ui'
import moment from 'moment'
import store from '@/store'
import wx from 'weixin-js-sdk'

export function Message (str) {
  return this.$createToast({
    txt: str,
    type: 'error'
  }).show()
}

export function result(row) {
  var result = [];
  for(var i=0;i<row.length;i+=3){
    result.push(row.slice(i,i+3));
  }
  console.log('原始数据',row)
  console.log('组合后的数据',result)
  return result
}

// 获取从业年数
export function getDateYear(year) {
  console.log('year=',year);
  let a = new Date().getFullYear();
  let b = year;
  let num;
  var arrA = a.toString().split("-");
  var arrB = b.toString().split("-");
  if (year === '请选择') {
    num = '小于1'
  } else {
    if(arrA[1]<arrB[1]||arrA[2]<arrB[2]){
      num = arrA[0] - arrB[0]-1;
    }else{
      num = arrA[0] - arrB[0];
    }
  }
  // console.log('year=',num);
  return num;
}

// 种类数组匹配返回数组
export function classType(arr) {
  var arrList = []
  var classStr = {
    "JCDX01":"猪",
    "JCDX02":"鸡",
    "JCDX03":"鸭",
    "JCDX04":"鹅",
    "JCDX05":"牛",
    "JCDX06":"马",
    "JCDX07":"羊",
    "JCDX08":"兔",
    "JCDX09":"犬",
    "JCDX10":"猫",
    "JCDX11":"鸽",
    "JCDX12":"鱼",
    // "JCDX13":"畜禽饮用水",
    "JCDX14":"饲料",
    // "JCDX15":"动物源性产品",
    "JCDX16":"兽药",
    "JCDX17":"水貂",
    // "JCDX18":"研发服务",
    "JCDX19":"疫苗",
    // "JCDX20":"动物实验小鼠",
    // "JCDX21":"消毒剂",
    "JCDX22":"水"
  }
  // for (let i=0; i<arr.length; i++) {
  //   console.log('dddd=',classStr)
  //   for (let key in classStr) {
  //     if (key == arr[i]) {
  //       console.log('222',classStr[key])
  //       arrList.push(classStr[key])
  //     }
  //   }
  // }
  arr.forEach((item,i) => {
    for (let key in classStr) {
      if (key == item) {
        arrList.push(classStr[key])
      }
    }
  })
  // console.log('arrList=',arrList)
  return arrList
}

// 判断是否是微信浏览器
export function iswx() {
  var ua = window.navigator.userAgent.toLowerCase();
  if(ua.match(/MicroMessenger/i) == 'micromessenger'){
    return true;
  } else {
    return false;
  }
}

// 数组去重
export function unique(arr) {
  console.log('arr',arr)
  const res = new Map();
  return arr.filter((arr) => !res.has(arr.id) && res.set(arr.id, 1))
}
export function unique1(arr) {
  console.log('arr',arr)
  const res = new Map();
  return arr.filter((arr) => !res.has(arr) && res.set(arr, 1))
}

// 判断客户端是否为安卓
export function isAndroid(){
  let u = navigator.userAgent;
  let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;   //判断是否是 android终端
  let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); 
  return isAndroid
}
// 解决软键盘出现之后页面留空白问题
export const iosInputHandle = () => {
  // 判断是否是ios
  var ua = navigator.userAgent;
  if (!!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) {
      let flag = false
      let pageBackNormFunc
      document.body.addEventListener('focusin', () => {
          // 软键盘弹起事件
          flag = true
          pageBackNormFunc && clearTimeout(pageBackNormFunc)
      })
      document.body.addEventListener('focusout', () => {
          // 软键盘关闭事件
          if (flag) {
              pageBackNormFunc = setTimeout(function () { 
                  // 当键盘收起的时候让页面回到原始位置
                  window.scrollTo({ top: 0, left: 0, behavior: 'smooth' }) 
              }, 200)
          }
          flag = false
      })
  }
}


// 获取上周开始结束日期
export function getLastWeek(i) {
  let weekOfDay = parseInt(moment().format('E'));//计算今天是这周第几天
  let last_monday = moment().subtract(weekOfDay + 7 * i - 1, 'days').format('YYYY-MM-DD');//周一日期
  let last_sunday = moment().subtract(weekOfDay + 7 * (i - 1), 'days').format('YYYY-MM-DD');//周日日期
  return [last_monday, last_sunday]
}

 /**
* 获取后 i 周的周一和周日日期，并以数组的方式返回。
* 当 i=1，获取的是下周一和下周日的日期；
* 当 i=2，获取的是下下周一和下下周日的日期
* ...以此类推
* @param i
*/
export function getNextWeek(i) {
  let weekOfDay = parseInt(moment().format('E'));//计算今天是这周第几天
  let next_monday = moment().add((7 - weekOfDay) + 7 * (i - 1) + 1, 'days').format('YYYY-MM-DD');//周一日期
  let next_sunday = moment().add((7 - weekOfDay) + 7 * i, 'days').format('YYYY-MM-DD');//周日日期
  return [next_monday, next_sunday]
}

// 秒转换时分
export function secondToDate(result) {
  var h = Math.floor(result / 3600) < 10 ? '0'+Math.floor(result / 3600) : Math.floor(result / 3600);
  var m = Math.floor((result / 60 % 60)) < 10 ? '0' + Math.floor((result / 60 % 60)) : Math.floor((result / 60 % 60));
  var s = Math.floor((result % 60)) < 10 ? '0' + Math.floor((result % 60)) : Math.floor((result % 60));
  // return result = h + ":" + m + ":" + s;
  return result = h + "小时" + m + "分";
}

// 日期format
export function formatDate (date) { 
  var date = new Date(date);
  var Y = date.getFullYear() + '-';
  var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
  // var D = date.getDate() + ' ';
  var D = (date.getDate() < 10 ? '0'+ date.getDate() : date.getDate()) + ' ';
  var h = date.getHours() + ':';
  var m = date.getMinutes() + ':';
  var s = date.getSeconds(); 
  // 输出结果：2014-04-23 18:55:49
  return Y + M + D
}

// 日期字符串类型
export function dateToString(date){ 
  var year = date.getFullYear(); 
  var month =(date.getMonth() + 1).toString(); 
  var day = (date.getDate()).toString();  
  if (month.length == 1) { 
      month = "0" + month; 
  } 
  if (day.length == 1) { 
      day = "0" + day; 
  }
  var dateTime = year + "-" + month + "-" + day;
  return dateTime; 
}

// 时间戳转换为日期格式
export function ConveTime(str,type){
  var date = new Date(str);
  var Y = date.getFullYear() + '-';
  var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
  var D = date.getDate() + ' ';
  var h = date.getHours() + ':';
  var m = (date.getMinutes() < 10 ? '0'+date.getMinutes() : date.getMinutes()) + ':';
  var s = date.getSeconds(); 
  if(type == 'date'){
    return Y + M + D
  }else{
    return Y + M + D + h + m + s
  }
}

// 微信分享
export async function wxshare(imgurl,title,desc) {
  const { data } = await store.dispatch('report/wxshare')
  // console.log('wx=',data)
  var shareUrl1 = window.location.href;
  var img = imgurl;
  var name = title;
  var descstr = desc;
  var appId = data.appid;
  var timestamp = data.timestamp;
  var nonceStr = data.noncestr;
  var signature = data.signature;
  wx.config({
    debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
    appId: appId, // 必填，公众号的唯一标识
    timestamp: timestamp, // 必填，生成签名的时间戳
    nonceStr: nonceStr, // 必填，生成签名的随机串
    signature: signature,// 必填，签名，见附录1
    jsApiList: ["onMenuShareTimeline", "onMenuShareAppMessage"], // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
    openTagList: ['wx-open-launch-app']
  });
  wx.ready(function(){
    let imgurl = img;
    let title = name;
    let desc = descstr;
    wx.error(function(res){ // config 信息验证失败会执行 error 函数，如签名过期导致验证失败，具体错误信息可以打开 config 的 debug 模式查看，也可以在返回的 res 参数中查看，对于 SPA 可以在这里更新签名。
        // alert("errorMSG:"+res.errMsg);
    });
    wx.onMenuShareTimeline({
      title: title, // 分享标题
      desc: desc, // 分享描述
      link: shareUrl1, // 分享链接
      imgUrl: imgurl, // 分享图标
      success: function () {
        // 用户确认分享后执行的回调函数
        this.$createToast({
          type: 'correct',
          txt: '分享成功',
          time: 1000
        }).show()
      },
      cancel: function () {
        // 用户取消分享后执行的回调函数
        this.$createToast({
          txt: '分享失败',
          type: 'error'
        }).show()
      }
    });
    wx.onMenuShareAppMessage({
        title: title, // 分享标题
        desc: desc, // 分享描述
        link: shareUrl1, // 分享链接
        imgUrl: imgurl, // 分享图标
        success: function () {
          // 用户确认分享后执行的回调函数
          this.$createToast({
            type: 'correct',
            txt: '分享成功',
            time: 1000
          }).show()
        },
        cancel: function () {
          // 用户取消分享后执行的回调函数
          this.$createToast({
            txt: '分享失败',
            type: 'error'
          }).show()
        }
    });
  });
}
